<template>


	<el-container class="lables" style="width: 80%;margin-left: 10%;">
		<el-row style="margin-top: 49px;margin-right: 10px;">
		  <el-button type="primary"  @click="upDingshi()">更新定时设置</el-button>
		</el-row>
		<el-row  class="la-list">
			<el-col :span="15" class="first">
        <el-row style="text-align: center;font-size: 28px;">
        </el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in list1" :key="index">
					<div class="lable-o" style="float: left;">
          {{item.name}}({{item.num}})
          </div>
          <div class="lable-o" style="float: left;" @click="up(item.id,'XZ',item.name)">
          {{item.tname}}
          </div>
				</el-row>
			</el-col>

		</el-row>
    <el-dialog
      :title="waxname"
      :visible.sync="dialogVisibleci"
      width="30%"
      >
      <el-row>
        <el-col>
          <h5 style="float: left;margin-right: 10px;">状态:</h5>
          <el-select v-model="type" style="float: left;width: 70%;margin-top: 8px;"  filterable placeholder="请选择" >
              <el-option
                v-for="item in tArr"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-col>

      </el-row>
      <el-row style="margin-top: 10px;" v-if="type >0">
        <el-col :span="10">
          <h5 style="float: left;margin-right: 10px;">小时:</h5>
          <el-input style="float: left;width: 70%;margin-top: 8px;" v-model="hour" placeholder="请输入小时"></el-input>

        </el-col>
        <el-col :span="10">
          <h5 style="float: left;margin-right: 10px;">分钟:</h5>
          <el-input style="float: left;width: 70%;margin-top: 8px;" v-model="minute" placeholder="请输入分钟"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleci = false">取 消</el-button>
        <el-button type="primary" @click="upSub()">确 定</el-button>
      </span>
    </el-dialog>
	</el-container>



</template>

<script>

  export default {
    data() {
      return {
        list1:[],
        dialogVisibleci:false,
        type:0,
        tArr:[{'id':0,'name':'不更新'},{'id':1,'name':'定时更新'},{'id':2,'name':'间隔更新'}],
        hour:0,
        minute:0

      };
    },
	created() {

	  this.loadData();

	},

	methods:{
    up(id,t,name){
      if(id == 467){
        alert('请勿更新兜底')
        return false
      }
      this.lid = id
      this.wax = t
      this.waxname = name+'功能定时更新设置'
      this.dialogVisibleci = true
    },
    upDingshi(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/upDingShi'
      })
      .then(res=>{
        this.$message({
        	type: 'success',
        	message: '更新成功'
        });

      })
      .catch(err=>{
        this.$message({
        	type: 'success',
        	message: '更新成功1'
        });
      });
    },
    upSub(){
      if(this.type >0 && this.hour == 0 && this.minute == 0){
        this.$message({
        	type: 'error',
        	message: '请设置时间'
        });
        return false
      }

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/qwaxdUpdate',
      	params:{
          id:this.lid,
          type:this.type,
          hour:this.hour,
          minute:this.minute
        }
      })
      .then(res=>{
        this.lid = 0
        this.wax = ''
        this.waxname = '定时更新设置'
        this.dialogVisibleci = false
        this.$message({
        	type: 'success',
        	message: '更新成功'
        });
        this.loadData();

      })
      .catch(err=>{

      });
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://y31p.yoooooo.com/index.php/index/data/qredis'
			})
			.then(res=>{
				this.list1 = res.data.list1;


			})
			.catch(err=>{

			});
		},


	}


  }
</script>

<style>

	.content{

		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{

		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;

	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsx{
		width: 30%;
		margin-left: 10%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/qredis.vue